// extracted by mini-css-extract-plugin
var _1 = "EmbeddedFormValue_notice__7f212";
export { _1 as "notice" }
